import { Box, Drawer, styled } from "@mui/material";
import { drawerWidth as defaultDrawerWidth } from "../../../../consts/drawerWidth";
import { IStyledRootProps } from "./types";

const StyledRoot = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== "isFullscreen" && prop !== "chatWidth",
})<IStyledRootProps>(({ theme, isFullscreen, chatWidth }) => {
    const width = isFullscreen ? "100vw" : (chatWidth ?? defaultDrawerWidth);

    return {
        width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width,
            maxWidth: isFullscreen ? "100vw" : width,
            boxSizing: 'border-box',
            height: isFullscreen ? "100vh" : "100%",
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflowX: 'hidden',
            right: 0,
            top: 0,
        },
        // no mobile o chat ocupa a tela inteira, independente do estado de fullscreen
        [theme.breakpoints.down("md")]: {
            width: "100vw",
            '& .MuiDrawer-paper': {
                width: "100vw",
                maxWidth: "100vw",
                height: "100vh",
                "@supports (height: 100dvh)": {
                    height: "100dvh",
                },
            },
        },
    };
})

// Thin drag strip glued to the drawer paper's left edge — lights up on hover/drag so it reads as
// grabbable, invisible otherwise so it doesn't compete with the chat content right next to it.
const StyledResizeHandle = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: 6,
    cursor: "ew-resize",
    zIndex: 2,
    backgroundColor: "transparent",
    transition: "background-color 0.15s ease",
    "&:hover": {
        backgroundColor: (theme as any).palette.primary.main,
    },
    // no mobile não há resize por arrasto — o chat é sempre tela cheia
    [theme.breakpoints.down("md")]: {
        display: "none",
    },
}))

export {StyledRoot, StyledResizeHandle}
